import { tw } from 'utils/tailwindUtils';
import InfoSuitcase from './InfoSuitcase';
import {
  ViajeCanalesDeIngreso,
  ViajeTrasladoTipoServicio
} from 'app/viaje/models';
import {
  TransferReservationType
} from 'app/viaje/viajeTraslado/viajeTraslado/models/TransferReservationPartial';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { useThemeContext } from 'shared/context/themeContext';
import { TransferReservationOpenedModel } from 'app/viaje/viajeTraslado/abierto/models/TransferReservationOpened';
import { TransferReservationPendingModel } from 'app/viaje/viajeTraslado/pendiente/models/TransferReservationPending';
import { TransferReservationManagmentModel } from 'app/viaje/viajeTraslado/gestion/models/TransferReservationManagment';
import { TransferReservationManagementListModel } from 'app/viaje/viajeTraslado/gestion/models/TransferReservationManagementList';

type Props = {
  current: TransferReservationPendingModel | TransferReservationOpenedModel | TransferReservationManagmentModel | TransferReservationManagementListModel;
  isMobileOrTablet: boolean;
};

const Client = ({
  current,
  isMobileOrTablet,
}: Props) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';
  const entryForApp = current.entryChannel === ViajeCanalesDeIngreso.APP;
  const isBusesService =
    'service_type' in current
      ? current.service_type === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES
      : 'serviceType' in current
        ? current.serviceType === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES
        : false;

  return (
    <div className="flex flex-col gap-2 relative">
      <div className="flex justify-between text-sm items-center">
        {isMobileOrTablet ? <p>Cliente</p> : null}
        <div className="flex flex-col gap-2">
          {current.type === TransferReservationType.PARTICULAR_CORPORATIVE && (
            <p
              className="text-start "
              style={{
                color: '#0270AB',
                textShadow: '1px 1px 1px #61FFD0',
                border: '1px solid #61FFD0',
                width: 'fit-content',
                padding: '0px 4px',
                borderRadius: '4px',
                fontSize: '10.5px'
              }}
            >
              {current.client.company_name}
            </p>
          )}
          <p
            className={`w-28 text-sm ${isBusesService
              ? 'text-purple-600 dark:text-purple-300'
              : current.type === TransferReservationType.CORPORATIVE &&
                !current.pay_with_cash
                ? 'text-blue-500 dark:text-blue-300'
                : 'text-black dark:text-ink-dark'
              }`}
          >
            {current.client.name}
          </p>
          {entryForApp && (
            <div
              className="flex items-center gap-0.5"
              style={{
                borderRadius: '50%',
                padding: '3px',
                width: 'fit-content',
                position: 'absolute',
                left: isMobileOrTablet ? '60px' : '-30px',
                top: isMobileOrTablet ? '0px' : '-20px'
              }}
            >
              <FontAwesomeIcon
                icon={faMobileAlt}
                style={{ fontSize: '14px', color: isDark ? '#67c7ffff' : '#0000FF' }}
              />
              <FontAwesomeIcon
                icon={faArrowRight}
                style={{ fontSize: '8px', color: isDark ? '#67c7ffff' : '#0000FF' }}
              />
            </div>
          )}
        </div>

        <InfoSuitcase
          airportDetail={current.airport_details}
          idTravel={current.id}
          locations={current.locations}
        />
      </div>
      <div
        className={tw('hidden flex-col gap-1', {
          flex: current.lltpais ? true : false
        })}
      >
        <div className="flex text-sm w-fit text-blue-100 font-bold px-2 py-1 bg-blue-900 rounded-lg mb-1">
          LLT-País
        </div>
        <p className="text-light w-36 text-xs leading-none text-gray-400 flex justify-between">
          Proveedor
          <span>${Number(current?.lltpais?.provider_price ?? 0)}</span>
        </p>
        <p className="text-light w-36 text-xs leading-none text-gray-400 flex justify-between">
          Cliente
          <span>${Number(current?.lltpais?.customer_price ?? 0)}</span>
        </p>
      </div>
      <div
        className={tw('hidden flex-col gap-1', {
          flex: current.bus_requirement ? true : false
        })}
      >
        <p className="text-light w-36 text-xs leading-none text-gray-400 flex justify-between">
          Proveedor
          <span>${Number(current?.bus_requirement?.provider_price ?? 0)}</span>
        </p>
        <p className="text-light w-36 text-xs leading-none text-gray-400 flex justify-between">
          Cliente
          <span>${Number(current?.bus_requirement?.customer_price ?? 0)}</span>
        </p>
      </div>
    </div>
  );
};

export default Client;
